import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Container, Badge } from 'react-bootstrap-5';

import {
  callListUrl,
  CALL_LISTS_INDEX,
  CALL_LISTS_SEARCH
} from 'bundles/connect/helpers/prospect_api';
import CallListCallCard from './call_list_call_card';
import type { Avatar, CallProgress } from 'bundles/connect/types';
import { selectCallListItems } from '../store/selectors/results';
import Avatars from '../profile/avatars';

interface CallListItemsHeaderProps {
  avatars: Avatar[];
  callListId: number;
  callListName: string;
  callProgress: CallProgress;
  prospectTeamAccount: boolean;
}

export default function CallListItemsHeader({
  avatars,
  callListId,
  callListName,
  callProgress,
  prospectTeamAccount
}: CallListItemsHeaderProps) {
  const callListItems = useSelector(selectCallListItems);

  return (
    <div className="bg-white py-4 d-md-block d-none">
      <Container fluid>
        <Row className="gy-3">
          <Col>
            <Row className="flex-column gap-2">
              <Col>
                <nav>
                  <ol className="breadcrumb my-0 align-items-center">
                    <li className="breadcrumb-item my-0">
                      <a className="text-muted" href={callListUrl(CALL_LISTS_SEARCH)}>
                        <i className="far fa-home"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item my-0">
                      <a className="text-muted" href={callListUrl(CALL_LISTS_INDEX)}>
                        Lists
                      </a>
                    </li>
                  </ol>
                </nav>
                {prospectTeamAccount && (avatars.length > 1 ? (
                  <Avatars avatars={avatars} />
                ) : (
                  <Badge bg="light" className="text-muted fs-x-small">Private</Badge>
                ))}
                <h5>{callListName}</h5>
              </Col>
            </Row>
          </Col>
          <Col>
            <CallListCallCard
              callListId={callListId}
              callListItems={callListItems}
              callProgress={callProgress}
            />

          </Col>
        </Row>
      </Container>
    </div>
  );
}
